import HtmlEmailBody from './HtmlEmailBody';
import React from 'react'
import { emailBodyLinks } from './emailBodyLinks'
import { P } from '../../../../../../AbstractElements'
import { userBodyData } from '../../../../../../Data/Applications/LetterBox'

export default function UserBody({ body, isLoading }: { body?: string | null; isLoading?: boolean }) {
    const trimmed = (body ?? "").trim();
    const isHtml = /^<(?:!doctype\s+html|html|head|style|meta|body|div|p|table|span|br|a)(?:\s|>|\/)/i.test(trimmed);
    const hasBody = trimmed.length > 0 && trimmed.toLowerCase() !== "undefined";
    const content = hasBody ? [trimmed] : userBodyData.map((item) => item.text);

    return (
        <div className="user-body w-100" style={{ minWidth: 0, overflowWrap: "anywhere" }}>
            {isLoading && !hasBody && <P className="f-light">Caricamento contenuto...</P>}
            {hasBody && isHtml ? (
                <HtmlEmailBody html={trimmed} />
            ) : (
                !isLoading &&
                content.map((text, index) => (
                    <P key={index} style={{ whiteSpace: "pre-wrap", width: "100%", maxWidth: "none" }}>
                        {emailBodyLinks(text).map((part, partIndex) => part.href ? (
                            <a key={partIndex} href={part.href} target={/^https?:\/\//i.test(part.href) ? "_blank" : undefined} rel="noopener noreferrer" style={{ overflowWrap: "anywhere" }}>
                                {part.text}
                            </a>
                        ) : <React.Fragment key={partIndex}>{part.text}</React.Fragment>)}
                    </P>
                ))
            )}
        </div>
    )
}
